import { getFeatures } from "@/api/endpoints/features";
import { useQuery } from "@tanstack/react-query";

export const useFeatures = () => {
  return useQuery({
    queryKey: ["features"],
    queryFn: () => getFeatures(),
  });
};
